<div
  class="flex items-center justify-center font-semibold"
  [ngClass]="{
    'h-4 w-4': size === 2,
    'h-5 w-5 text-lg': size === 3
  }"
  >Aa</div
>
